import axios from "axios";
import React, { useState, useEffect } from "react";
import { getCategory, getImage, setChildData, token } from "../../API";
import EditStyles from "../EditPost/EditStyles";
import { Editor } from "react-draft-wysiwyg";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import FileUpload from "../FileUpload";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import FileUploadChild from "../FileUploadCHild";
const EditPostChild = ({ data, parent, imgpath, success, successCallback }) => {
  // getting
  const [datatoSend, setDatatoSend] = useState(data);
  const [texts, setTexts] = useState({
    textUz: data.textUz,
    textUzK: data.textUzK,
    textRu: data.textRu,
    textEn: data.textEn,
  });
  const [title, setTitle] = useState({
    titleUz: data.titleUz,
    titleUzK: data.titleUzK,
    titleEn: data.titleEn,
    titleRu: data.titleRu,
  });
  const [imgPath, setImgPath] = useState("NEWS_CHILD");
  const [active, setActive] = useState("textUz");
  const menus = [
    { t: "textUz" },
    { t: "textUzK" },
    { t: "textEn" },
    { t: "textRu" },
  ];
  // active title
  const [activeTitle, setActivetitle] = useState("titleUz");
  const [titleInput, setTitleInput] = useState("");
  // editing
  const [textBool, setTextBool] = useState("d-block");
  const [inputBool, setInputBool] = useState("d-none");
  const [input, setInput] = useState(EditorState.createEmpty());

  // image
  const [image, setImage] = useState(data.file.link ? data.file.link : "");

  const htmlToDraft = (text) => {
    const blocksFromHTML = convertFromHTML(text);

    const content = ContentState.createFromBlockArray(
      blocksFromHTML.contentBlocks,
      blocksFromHTML.entityMap
    );
    setInput(EditorState.createWithContent(content));
  };

  const viewHandle = (v) => {
    if (v === "d-block") {
      setTextBool("d-none");
      setInputBool("d-block");
    } else {
      setTextBool("d-block");
      setInputBool("d-none");
    }
    setTitleInput(title[activeTitle]);
    htmlToDraft(texts[active]);
  };
  const saveHandle = (path) => {
    if (path == "texts") {
      let oldVals = title;
      oldVals[activeTitle] = titleInput;
      setTitle(oldVals);
      // draftToHtml(convertToRaw(engText.getCurrentContent()))

      let oldTexts = texts;
      oldTexts[active] = draftToHtml(convertToRaw(input.getCurrentContent()));
      setTexts(oldTexts);
      viewHandle("d-none");
    } else {
      viewHandle("d-none");
    }
  };

  //   change image
  const [changeImgBool, setChangeImgBool] = useState("d-block");
  const [fileBool, setFileBool] = useState("d-none");
  const [img, setImg] = useState(null);
  const [imgBool, setImgBool] = useState("d-none");
  const pictureId = (value) => {
    setImage(value.data.object[0].link);
    setImg(value.data.object[0].fileId);
    console.log(value.data.object[0].fileId);
    setImgBool("d-block");
    cancelHandle();
  };

  const imageHandle = () => {
    setChangeImgBool("d-none");
    setFileBool("d-block");
  };
  const cancelHandle = () => {
    setChangeImgBool("d-block");
    setFileBool("d-none");
  };
  const saveEditedPost = () => {
    let editedPost = {
      id: data.id,
      newsId: parent,
      link: data.link,
      fileId: img !== null ? img : data.file.fileId,
      textEn: texts.textEn,
      textRu: texts.textRu,
      textUz: texts.textUz,
      textUzK: texts.textUzK,
      titleEn: title.titleEn,
      titleRu: title.titleRu,
      titleUz: title.titleUz,
      titleUzK: title.titleUzK,
    };
    setChildData(editedPost, success, successCallback);
    // attachmentId: img,
    // categoryId: category,

    // textEn: draftToHtml(convertToRaw(engText.getCurrentContent())),
    // textRu: draftToHtml(convertToRaw(ruText.getCurrentContent())),
    // textUz: draftToHtml(convertToRaw(uzText.getCurrentContent())),

    // titleEn: engTitle,
    // titleRu: ruTitle,
    // titleUz: uzTitle,
  };
  // delete child
  const DeleteThisCHild = () => {
    const url = `http://164.90.236.174:1988/koinot/newsChild/${data.id}`;
    try {
      const res = axios.delete(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      success(true);
      successCallback(`News Child successfully deleted`, "s");

      return res;
    } catch (error) {
      console.error(error);
      return { error: true, error };
    }
  };
  return (
    <EditStyles>
      <div className="row">
        <div className="col-10 border p-3">
          <div className="">
            {menus.map((v, i) => (
              <button
                key={i}
                onClick={() => {
                  setActive(v.t);
                  htmlToDraft(texts[v.t]);
                  setTitleInput(Object.values(title)[i]);
                  setActivetitle(Object.keys(title)[i]);
                }}
                className={`btn col-3 my-1 ${
                  active === v.t ? "btn-success" : "btn-outline-success"
                }`}
              >
                {v.t}
              </button>
            ))}
          </div>
          {/* text va input */}
          <code>Title:</code>
          <h5 className={`${textBool}`}>{title[activeTitle]}</h5>
          <input
            type="text"
            className={`form-control ${inputBool}`}
            value={titleInput}
            onChange={(e) => setTitleInput(e.target.value)}
          />
          <hr />
          <code>Text:</code>
          <div className="w-100 wrapper">
            <p
              className={`${textBool}`}
              dangerouslySetInnerHTML={{ __html: texts[active] }}
            />
          </div>

          <div className={inputBool}>
            <Editor
              editorState={input}
              wrapperClassName="demo-wrapper"
              editorClassName="demo-editor"
              toolbar={{
                options: [
                  "inline",
                  "blockType",
                  "image",
                  "list",
                  "textAlign",
                  "link",
                  "history",
                ],
              }}
              onEditorStateChange={(e) => {
                setInput(e);
              }}
            />
          </div>
        </div>

        {/* edit, cancel, save, delete*/}
        <div className="col-2 border p-2 d-flex">
          <span className={`${textBool} w-100`}>
            <button
              className="btn btn-info col-12"
              onClick={() => {
                viewHandle("d-block");
                setTitleInput(title[activeTitle]);
              }}
            >
              Edit
            </button>
          </span>

          <span className={`${inputBool} w-100`}>
            <button
              className="btn btn-warning col-12"
              onClick={() => viewHandle("d-none")}
            >
              Cancel
            </button>
            <button
              onClick={() => saveHandle("texts")}
              className="btn btn-success  col-12"
            >
              Save
            </button>
          </span>
        </div>
        {/* edit, cancel, save, delete*/}
      </div>
      <div className="row border">
        <div className="col-10 border">
          <p className="fw-bold my-2">Image</p>
          {image !== null ? (
            <img src={image} alt="" className={`img-fluid`} />
          ) : (
            ""
          )}
        </div>
        <div className="col-2 border">
          <p className="fw-bold my-2">Rasmni o'zgartirish</p>
          <span className={`${changeImgBool} col-12 `}>
            <button
              className="btn btn-info col-6 my-2 mx-auto"
              onClick={imageHandle}
            >
              Change image
            </button>
          </span>
          <span className={`${fileBool}`}>
            <button
              onClick={cancelHandle}
              className={`btn btn-warning col-6 my-2`}
            >
              Cancel
            </button>

            <FileUploadChild
              callback={pictureId}
              path={"NEWS_CHILD"}
              came={img !== null ? true : false}
            />
            <p className={`text-success ${imgBool}`}>Rasm almashtirildi</p>
          </span>
        </div>
      </div>
      {data.id !== undefined ? (
        <div className="w-100">
          {" "}
          <button onClick={DeleteThisCHild} className="btn btn-danger col-6">
            Ushbu tarkibni o'chirish
          </button>{" "}
          <button onClick={saveEditedPost} className="btn btn-info col-6">
            Saqlash
          </button>
        </div>
      ) : (
        <button onClick={saveEditedPost} className="btn btn-info col-12">
          Saqlash
        </button>
      )}
    </EditStyles>
  );
};

export default EditPostChild;



// WEBPACK FOOTER //
// ./src/Components/EditpostChild/index.js